// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"ee68de00","168":"848a630a","372":"0bad95c8","872":"96dc139f"}[chunkId] + ".chunk.js";
};